import { useContext } from "react";
import Checkbox from "../../Checkbox/Checkbox";
import { ConfigurationContext, DispatchContext } from "./ConfigurationContext";
import FieldGroup from "../../FieldGroup/FieldGroup";

const FormStepSizes = ({ sizeField }) => {
  const { size } = useContext(ConfigurationContext);
  const dispatch = useContext(DispatchContext);

  const isSizeSelected = (option) => option.id === size?.id;
  const handleSizeChange = (option) => {
    dispatch({ type: "SELECT_SIZE", payload: option });
  };

  const fieldGroupId = `${sizeField.name}-radio-group`;

  return (
    <FieldGroup
      title={sizeField.title}
      id={fieldGroupId}
      details={sizeField.details}
    >
      {sizeField.options.map((option) => (
        <Checkbox
          key={option.id}
          type="radio"
          name={fieldGroupId}
          isChecked={isSizeSelected(option)}
          {...option}
          onChange={handleSizeChange}
        />
      ))}
    </FieldGroup>
  );
};

export default FormStepSizes;
